import React, { Fragment } from "react";
import { Container, Row, Card, Col, Image} from "react-bootstrap";
import { Link } from "react-router-dom";


const Speaking = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/hackingCreativity/professionalDevelopment.jpg)', backgroundSize: 'cover'}}>
        <h1 className="display-3" style={{color:'white'}}>Keynotes</h1>
      </div> 

      <Container className="mt-5 p-5">
         
         <Row>
            <p className="lead"> Dr. Pronita Mehrotra speaks on a wide range of topics covering innovation, inclusion, artifical intelligence and the neuroscience of learning. </p>
            <p>See below for selected keynote speeches. Interested in hiring her for your next corporate or professional development event?</p>
            <p> <Link className="btn text-white" style={{backgroundColor:'#c87137'}} to="mailto:hello@mindantix.com" role="button">Email to learn more &raquo;</Link> </p>

         </Row>
         <Row className="mt-5 p-3" style={{backgroundColor: '#eef6fe'}}>
            <p className="lead" style={{color:'#639fdd', fontStyle:'italic'}}>
               &quot;Pronita Mehrotra delivered an extraordinary presentation at our event, captivating our audience with her deep expertise in cognitive creativity. Her enthusiastic delivery, combined with clear, tangible takeaways, left our audience inspired and equipped to foster creativity in their own organizations. Her message resonates across industries, making her an ideal speaker for diverse audiences seeking to enhance innovation and success.&quot;
            </p>
            <p className="lead text-right">
               -Erin Loman Jeck (CEO, Transformational Speakers Agency)
            </p>

         </Row>
      </Container>

      <Container className="p-5">
               <Card className="border-info mb-5"> 
                  <Row>
                     <Col className="col-12 col-md-4 p-3 d-flex align-items-center justify-content-center">
                        <img className="img-fluid border border-info"
                           src="/images/hackingCreativity/SandboxToBoardroom.jpg"
                           height="100%"
                           width = "100%"
                           alt="Sandbox To Boardroom"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title style={{color:'#c87137'}}>
                              From Sandbox to Boardroom
                           </Card.Title>
                           <Card.Subtitle style={{color:'#c87137'}}>Corporate Leadership Lessons From Teaching Creativity To Students</Card.Subtitle>
                           <Card.Text className="small mt-3">
                             <p>In this thought-provoking keynote, we delve into the profound insights gleaned from teaching creative thinking to students and their remarkable relevance to leadership, motivation, and engagement in the corporate world. </p>
                             <p>By examining the cognitive processes that fuel creative thinking in children, we will discover a blueprint for cultivating a culture of fearless ideation and collaboration within organizations. Through captivating anecdotes and practical strategies, learn how to overcome the crippling fear of failure that often stifles innovation, and harness the power of diverse perspectives to drive groundbreaking solutions.</p>
                             <p>Join us as we transform traditional leadership paradigms, drawing inspiration from the unfiltered creativity of children, to cultivate environments where creativity flourishes, innovation thrives, and every voice is heard.</p>
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>  
               </Card>


               <Card className="border-info mb-5"> 
                  <Row>
                     <Col className="col-12 col-md-4 p-3 d-flex align-items-center justify-content-center">
                        <img className="img-fluid border border-info"
                           src="/images/hackingCreativity/InclusiveCultureForInnovation.jpg"
                           height="100%"
                           width = "100%"
                           alt="Inclusive Culture"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title style={{color:'#c87137'}}>
                              How To Foster An Inclusive Culture And Drive Unparalleled Innovation 
                           </Card.Title>
                           
                           <Card.Text className="small mt-3">
                             <p>Diversity and inclusion have become synonymous with innovation. Yet, despite significant investments in DEI initiatives,organizations continue to underperform in realizing the full potential of diverse teams. This keynote will unveil the startling reality of the hidden costs incurred due to gender bias that stifle innovation and impede organizational growth.</p>
                             <p>Through groundbreaking research, we will explore the cognitive and psychological barriers that prevent women's ideas from being heard and valued. We will dissect the insidious mechanisms of evaluation apprehension, groupthink, cognitive dissonance, and tokenism that perpetuate gender inequality and hinder innovation.</p>
                             <p>Finally, we will share practical strategies for leaders to create environments where every voice is heard, valued, and amplified. By implementing simple and consistent processes, organizations can foster an inclusive culture and drive unparalleled innovation.</p>
                             <p>Prepare to be challenged, inspired, and equipped with the knowledge to transform your organization into a truly innovative powerhouse.</p>
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>  
               </Card>


               <Card className="border-info mb-5"> 
                  <Row>
                     <Col className="col-12 col-md-4 p-3 d-flex align-items-center justify-content-center">
                        <img className="img-fluid border border-info"
                           src="/images/hackingCreativity/AIInPractice.jpg"                 
                           alt="AI In Practice"
                        />

                     </Col>
                     <Col className="col-12 col-md-8 text-center">
                        <Card.Body>
                           <Card.Title style={{color:'#c87137'}}>
                              AI In Practice
                           </Card.Title>
                           <Card.Subtitle style={{color:'#c87137'}}>Catalyst For Human Potential Or A Crutch For Cognitive Decline?</Card.Subtitle>
                           <Card.Text className="small mt-3">
                             <p>In an age where artificial intelligence is rapidly reshaping our world, we find ourselves at a crossroads. While AI promises unprecedented efficiency and innovation, it also poses a profound threat to our cognitive abilities. Will it make us smarter or dumb us down? This keynote will delve into the neuroscience of learning, exploring how AI can both enhance and hinder our capacity for critical thinking, creativity, and problem-solving. </p>
                             <p>We will examine the implications for businesses and educational institutions, challenging the audience to consider the long-term consequences of our increasing reliance on AI. By understanding the potential pitfalls and harnessing the power of AI responsibly, we can shape a future where technology serves as a catalyst for human potential rather than a crutch for cognitive decline. This is a conversation every leader, educator, and parent must engage in to ensure we harness the power of AI while safeguarding human potential.</p>
                           </Card.Text>
                        </Card.Body>

                     </Col>
                  </Row>  
               </Card>
           

      </Container>

    </Fragment>
       
  );
};
  
export default Speaking;